<template>
    <div class="wrapper">
        <div class="text">Delivery</div>
        <div class="title">Machine Transport</div>
        <div class="flex">
            <div class="text">Machine transports of all types and sizes are not only required for almost every company relocation. Whether it’s a new machine delivery or a relocation – Schneider Industries takes on special transports of machines as part of relocations or as individual transports. </div>
            <div class="text">We utilise transport vehicles of our own for oversized, bulky and heavy equipment. Benefit from the experience of our well-trained drivers and teams, who will transport your machines reliably and quickly – worldwide.</div>
        </div>
        <ButtonOrange style="width: 189px;" @click="this.$scrollTo('footer');">Contact with us</ButtonOrange>
    </div>
</template>

<script>
import ButtonOrange from '@/components/UI/ButtonOrange.vue';
    export default {
        components: {
            ButtonOrange,
        },
    }
</script>

<style scoped>
.wrapper{
    padding-top: 88px;
}
.wrapper > .text{
/* Tabs/T1: 13px Medium */
color: rgb(85, 98, 114);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 10px;
}
.wrapper > .title{
/* Header/H2: 32px Medium */
color: rgb(5, 5, 5);
font-size: 32px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 16px;
}
.flex{
    display: flex;
    justify-content: space-between;
    gap: 32px;
    padding-bottom: 24px;
}
.flex .text{
color: rgb(85, 98, 114);
font-size: 24px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
max-width: 557px;
}

@media (max-width: 768px) {
    .flex{
        flex-direction: column;
    }
    .flex .text{
        max-width: unset;
    }
}
</style>